import creditCards from 'constants/creditCards'

const format = (id) => {
  return (
    (id && creditCards.CARD_FLAG_FORMAT_VALIDATION[id]) ||
    creditCards.DEFAULT_FORMAT
  )
}

export default format
